<template lang="html">
  <div class="order-time">
    <dateItem
      v-model="value"
      :count="count"
      :schedule="workDays"
      :fullDays="fullDays"
      :canClick="false"
      :showSimple="true"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import dateItem from '@/components/date'

export default {
  data() {
    return {
      value: '',
      count: 1
    }
  },
  computed: {
    ...mapState(['workDays', 'fullDays'])
  },
  components: {
    dateItem
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';
.order-time {
  //margin-top: rem(-80px);
}
</style>
